export default function populatePinForm() {
  const params = new URL(document.location).searchParams;
  const pin = params.get('pin');

  if (pin === null) {
    return;
  }

  // TODO: consolidate this with the selectors in global.js
  const pinField = document.querySelector('#pin-entry-field');
  pinField.value = pin;
}
